import ReportSummary from './ReportSummary';
import { Position } from 'models';
import Enums from 'utils/EnumsManager';

const { GROUPS_ZONE_TAG_ACTIONS } = Enums.REPORTS;
const actions = GROUPS_ZONE_TAG_ACTIONS.map(action => `__${action}`);

class ReportSummary_Trackable extends ReportSummary {
  constructor(params) {
    super(params);
    this.trackableFields = [
      'name',
      'position',
      // 'updatedAt',
      'groupSettings',
      'summarySettings',
      'orderSettings'
    ];
    this.committed = this.initCommittedData(params);
  }

  // Sync new changes after saved to backend
  // TODO: add implementations
  commitData(params) {
    // commit id
    // commit other data
  }

  initCommittedData(params) {
    const data = {};
    this.trackableFields.forEach(key => {
      if (key === 'position') {
        data.position = new Position(params.position);
      } else if (key === 'groupSettings') {
        //
        actions.forEach(a => {
          if (_.endsWith(params[key], a)) {
            params[key] = params[key] ? params[key].replace(a, '') : null;
          }
        });
        data[key] = params[key];
      } else if (key === 'orderSettings' && !_.isEmpty(params[key]) && params[key].field_name) {
        actions.forEach(a => {
          if (_.endsWith(params[key].field_name, a)) {
            params[key].field_name = params[key].field_name ? params[key].field_name.replace(a, '') : null;
          }
        });
        data[key] = params[key];
      } else {
        data[key] = params[key];
      }
    });
    return data;
  }

  isRevertable() {
    return !this.isChanged();
  }
  // TODO: Add implementation to compare committed data vs staged data
  isChanged() {
    return !this.trackableFields.some(key => {
      if (_.isObject(this[key])) {
        return (
          JSON.stringify(this.committed[key]) !== JSON.stringify(this[key])
        );
      }
      return this.committed[key] !== this[key];
    }, this);
  }

  revertData() {
    this.trackableFields.forEach(key => {
      if (key === 'position') {
        this[key] = new Position({
          x: this.committed[key].x,
          y: this.committed[key].y
        });
        return;
      }
      this[key] = this.committed[key];
    });
  }
}

export default ReportSummary_Trackable;



// WEBPACK FOOTER //
// ./src/models/Dashboards/ReportSummary_Trackable.js